import { gsap } from "gsap"
import Typewriter from "typewriter-effect/dist/core";

export default class Layout
{
    constructor(experience)
    {
        this.experience = experience
        this.textAdventure = this.experience.textAdventure
        this.camera = this.experience.camera
        this.renderer = this.experience.renderer
        this.debug = this.experience.debug
        this.waitingToCloseNav = false
        this.audio = this.experience.world.audio
        this.sizes = this.experience.sizes
        this.world = this.experience.world

        // NOTE: of the 3 different window modes, only fullscreen works right now :/

        this.params = {
            windowMode: 'fullscreen',
            navBoxSetting: 'fullscreen',
            colorProfile: 'grey',
            OSOnOpen: false,
            portfolioMode: true,
            OSOpened: false,

            webGLContained: true,
            renderHeight: 70,
            renderWidth: 50,
            leftOffset: 40,
            topOffset: 0,
        }

        this.fullscreenEnabled = false

        window.mobileCheck = function() {
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check
        }
        
        if(window.mobileCheck())
        {
            console.log("mobile controls activated")
            this.arrowControls = document.querySelector('.arrowControls')
            this.arrowControls.classList.remove('hidden')
            this.mobile = true
        }

        // Load new game
        this.experience.world.on('ready', () =>
        { 
            console.log("Loading Finished")
            this.firstPerson = this.experience.world.firstPerson
            if(this.mobile === true)
            {
                this.firstPerson.setArrowControls()
            }
            this.audio = this.experience.world.audio
            document.querySelector('.loadingText').classList.add('hidden')
            document.querySelector('.startGame').classList.remove('hidden')

                
            this.audio.beginAudio()
            document.querySelector('.titleScreen').classList.add('hidden')
            this.experience.params.appStart = true
            gsap.delayedCall(0.5, () =>
            {
                document.querySelector('.titleScreen').remove()
                if(this.experience.params.portfolioMode === true)
                {
                    this.setNavBox('disappear')
                }
                if(this.experience.params.portfolioMode === false)
                {
                    this.setNavBox('default')

                    this.textAdventure.progressToNextEvent(1)
                }
            })
              
        })

        
        this.setDomElements()
        this.setPortfolioExperience()
        this.setExperienceContainer()
        this.setNavBox()
        this.pinScrollToBottom()
        this.setDebug()

        if(this.params.webGLContained === true)
        {
            this.webGLContained()
        }

        if(this.params.OSOnOpen)
        {
            this.openOS()
        }
    }

    setDomElements()
    {
        this.transformingWebglContainer = false

        this.experienceContainer = document.querySelector('.experienceContainer')
        this.webGLContainer = document.querySelector('.webgl')
        this.navBox = document.querySelector('.navBox')
        this.textBox = document.querySelector('.textBox')
        this.arrowControls = document.querySelector('.arrowControls')
        this.folderTabs = document.querySelector('.folderTabs')
        this.fullscreen = document.querySelector('.fullscreen')
        this.visuals = document.querySelector('.visuals')
        this.visuals.style.visibility = 'hidden'

        this.webGLContainedWidth = null
        this.webGLContainedHeight = null

        this.folderTabs.addEventListener('click', () =>
        {
            if(this.params.navBoxSetting === 'hidden')
            {
                this.setNavBox('default')
            }
        })

        this.fullscreen.addEventListener('click', () =>
        {
            if(this.fullscreenEnabled === false)
            {
                this.fullscreenEnabled = true

                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.webkitRequestFullscreen) { /* Safari */
                    document.documentElement.webkitRequestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) { /* IE11 */
                    document.documentElement.msRequestFullscreen();
                }
            }
            else if(this.fullscreenEnabled === true)
            {
                this.fullscreenEnabled = false

                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                    document.msExitFullscreen();
                }
            }
        })

        this.focusedTab = 'tab1'

        this.textBoxButton = document.querySelector('.tab1')    
        this.settingsButton = document.querySelector('.tab2')       
        // this.settingsButton.addEventListener('click', () =>
        // {
        //     if(this.focusedTab === 'tab1')
        //     {
        //         this.textBoxButton.classList.remove('selected')
        //         this.settingsButton.classList.add('selected')
        //         this.focusedTab = 'tab2'
        //         this.experience.params.appStart = false
        //         this.textBox.classList.add('settings')

        //         this.settingsContainer = document.createElement('div')
        //         this.settingsContainer.classList.add('settingsContainer')
        //         this.navBox.appendChild(this.settingsContainer)

        //         this.graphicsSettingContainer = document.createElement('div')
        //         this.settingsContainer.appendChild(this.graphicsSettingContainer)
        //         this.graphicsSetting = document.createElement('select')
        //         this.graphicsSetting.innerHTML = 'Graphics Setting'

        //         this.lowGraphics = document.createElement('option')
        //         this.lowGraphics.innerHTML = 'Low'
        //         this.medGraphics = document.createElement('option')
        //         this.medGraphics.innerHTML = 'Medium'
        //         this.highGraphics = document.createElement('option')
        //         this.highGraphics.innerHTML = 'High'

        //         this.graphicsSetting.appendChild(this.highGraphics)
        //         this.graphicsSetting.appendChild(this.medGraphics)
        //         this.graphicsSetting.appendChild(this.lowGraphics)
        //     }
        // })

        // this.textBoxButton.addEventListener('click', () =>
        // {
        //     if(this.focusedTab === 'tab2')
        //     {
        //         this.settingsButton.classList.remove('selected')
        //         this.textBoxButton.classList.add('selected')
        //         this.focusedTab = 'tab1'
        //         this.experience.params.appStart = true
        //         this.textBox.classList.remove('settings')
        //         this.settingsContainer.remove()
        //     }
        // }) 
    }

    /**
     * ------------------------PORTFOLIO EXPERIENCE---------------------------------
     */

    setPortfolioExperience()
    {
        this.digitalWorksDom = document.querySelector('.digitalWorks')
        this.installationsDom = document.querySelector('.installations')
        this.filmsDom = document.querySelector('.films')
        this.webDesignDom = document.querySelector('.webDesign')
        this.aboutDom = document.querySelector('.about')

        this.selectedLink = null

        this.portfolioContainer = document.querySelector('.portfolioContainer')
        this.portfolioContainer2 = document.querySelector('.portfolioContainer2')
        this.portfolioLinks = document.querySelector('.portfolioLinks')
        this.informationDom = document.querySelector('.information')
        this.imagesDom = document.querySelector('.images')

        // create typewriter
        this.portfolioTypewriter = new Typewriter(this.informationDom, {loop: false, delay: 1, cursor: ""})

        if(this.mobile === true)
        {
            this.portfolioContainer2.classList.add('mobile')
            this.portfolioContainer2.classList.add('inactive')
            this.mobileBackButton = document.createElement('p')
            this.mobileBackButton.innerHTML = `<a class="mobileBack hidden" href="#">↩ Back</a>`
            this.experienceContainer.appendChild(this.mobileBackButton)
            this.informationDom.classList.add('mobile')

            document.querySelector('.mobileBack').addEventListener('click', () =>
            {
                this.portfolioContainer2.classList.add('inactive')
                document.querySelector('.mobileBack').classList.add('hidden')
                gsap.delayedCall(1, () =>
                {
                    
                    this.portfolioLinks.classList.remove('hidden')
                })
            })
        }

        this.digitalWorksDom.addEventListener('click', () =>
        {
            if(this.selectedLink != "digitalWorks")
            {
                if(this.mobile === true)
                {
                    this.portfolioContainer2.classList.remove('inactive')
                    this.portfolioLinks.classList.add('hidden')
                    document.querySelector('.mobileBack').classList.remove('hidden')
                }
                // Focus Selected Link
                this.selectedLink = "digitalWorks"
                this.digitalWorksDom.classList.add('selected')
                this.installationsDom.classList.remove('selected')
                this.filmsDom.classList.remove('selected')
                this.aboutDom.classList.remove('selected')
                this.webDesignDom.classList.remove('selected')
                // Animate Camera
                gsap.to(this.camera.instance.position, {x: -0, y: 1.2, z: 2, duration: 2, ease: "power1.inOut"} )
                gsap.to(this.camera.instance.rotation, {x: 0, y: 3, z: 0,  duration: 2, ease: "power1.inOut"} )
                // Hide then show content
                this.portfolioContainer2.classList.add('hidden')
                gsap.delayedCall(1, () =>
                {
                    this.imagesDom.innerHTML = ""
                    this.imagesDom.classList.remove('active')
                    // Set Content
                    this.informationDom.innerHTML = 
                    `
                    <a href="/environment1">Open Theatre</a>
                    <br>
                    <br>
                    <a href="/Environments/Cliffpass">Cliffpass</a>
                    <br>
                    <br>
                    <a href="#" class='explore'>        Explore Website →</a>
                    <br>
                    <br>
                    `
                    this.portfolioContainer2.classList.remove('hidden')
                    
                    this.imagesDom.classList.add('active')
                    document.querySelector('.explore').addEventListener('click', () =>
                    {
                        this.enter()
                        console.log("hello")
                    })
                })
            }
        })

        this.installationsDom.addEventListener('click', () =>
        {
            if(this.selectedLink != "installations")
            {
                if(this.mobile === true)
                {
                    this.portfolioContainer2.classList.remove('inactive')
                    this.portfolioLinks.classList.add('hidden')
                    document.querySelector('.mobileBack').classList.remove('hidden')
                }
                this.selectedLink = "installations"
                this.digitalWorksDom.classList.remove('selected')
                this.installationsDom.classList.add('selected')
                this.filmsDom.classList.remove('selected')
                this.aboutDom.classList.remove('selected')
                this.webDesignDom.classList.remove('selected')
                gsap.to(this.camera.instance.position, {x: -3.5, y: 1.6, z: -0, duration: 2, ease: "power1.inOut"} )
                gsap.to(this.camera.instance.rotation, {x: 0, y: 0.8, z: 0,  duration: 2, ease: "power1.inOut"} )

                this.portfolioContainer2.classList.add('hidden')
                gsap.delayedCall(1, () =>
                {
                    this.imagesDom.innerHTML = ""
                    this.imagesDom.classList.remove('active')
                    this.informationDom.innerHTML = 
                    `
                        <a class="points" href="#">Points of Intersection (2019)</a>
                        <br>
                        <br>
                        <a class="spectre" ref="#">My Spectre, Your Spectre (2023)</a>
                        <br>
                        <br>
                        <a class="acre" href="#">ACRE (2020)</a>
                        <br>
                        <br>
                    `
                    this.portfolioContainer2.classList.remove('hidden')
                    document.querySelector('.points').addEventListener('click', () =>
                    {
                        this.imagesDom.scrollTop = document.documentElement.scrollTop = 0
                        this.imagesDom.innerHTML = 
                        `
                            <p class="sublinkTitle">Points of Intersection (2019)</p>
                            <img class="firstImage" src="/images/pointsOfIntersection/reciept031.png">
                            <p class="sublinkParagraph">
                            <br>
                            Empathic transactions are always invisible, existing only as memories and meanings held within the person that conceived them. 
                            The installation 'Points of Intersection' was created in an attempt to make a transaction of empathy visbile and tangible: 
                            The interactive work allows viewers to press a button which will in turn cause a photo of their finger touching the button to be taken, printed as a receipt. 
                            The receipt may then become physical evidence of the button push, an action of empathy itself, begging the questions; how do images and objects affect how we remember empathic transactions? 
                            <br>
                            </p>
                            <img src="/images/pointsOfIntersection/POI.png">
                            <img src="/images/pointsOfIntersection/reciept049.png">
                            <img src="/images/pointsOfIntersection/intersections1.png">
                            <img src="/images/pointsOfIntersection/reciept029.png">
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                        `
                        this.imagesDom.classList.add('active')
                    })
                    document.querySelector('.spectre').addEventListener('click', () =>
                    {
                        this.imagesDom.scrollTop = document.documentElement.scrollTop = 0
                        this.imagesDom.innerHTML = 
                        `
                            <p class="sublinkTitle">My Spectre, Your Spectre (2023)</p>
                            <br>
                            <img class="firstImage" src="/images/spectre/spectre5.png">
                            <p class="sublinkParagraph">
                            <i>As installed in Eastern Bloc (Montreal, 2023)</i>
                                <br>
                                <br>
                            </p>
                            <img src="/images/spectre/spectre1.png">
                            <img src="/images/spectre/spectre2.jpg">
                            <img src="/images/spectre/spectre3.jpg">
                        `
                        this.imagesDom.classList.add('active')
                    })
                    document.querySelector('.acre').addEventListener('click', () =>
                    {
                        this.imagesDom.scrollTop = document.documentElement.scrollTop = 0
                        this.imagesDom.innerHTML = 
                        `
                            <p class="sublinkTitle">ACRE (2020)</p>
                            <br>
                            <img class="firstImage" src="/images/ACRE/diego.PNG">
                            <p class="sublinkParagraph">
                            <i>As installed in the Diego Rivera Gallery (San Francisco, 2020)</i>
                            <br>
                            <br>
                            Google maps and satellite view has given us the ability to ‘zoom out’. 
                            This act of distancing ourselves allows us to ignore the specific, the contextual, in exchange for a broad but superficial understanding of our world.
                            In light of the ongoing California wildfires, ACRE is a case study of the many ways we categorize, simplify, generalize, and ‘slice’ our environment as a response to disaster and turmoil:
                            The single pixel, lost in a sea of resolutions, the 'X' denoting a landmark or spot of interest,  and a sample of dirt extracted from grounds where the forest fires wrought havoc.
                            <br>
                            <br>
                            View the visual program online <a href="https://www.juliendarling-funk.com/ACRE">here.</a>
                            <br>
                            <br>
                            </p>
                            <img src="/images/ACRE/julien1.jpg">
                            <img src="/images/ACRE/julien3.jpg">
                            <img src="/images/ACRE/julien4.jpg">
                            <img src="/images/ACRE/julien5.jpg">
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                            <br>
                        `
                        this.imagesDom.classList.add('active')
                    })
                })
            }
        })

        this.filmsDom.addEventListener('click', () =>
        {
            if(this.selectedLink != "films")
            {
                if(this.mobile === true)
                {
                    this.portfolioContainer2.classList.remove('inactive')
                    this.portfolioLinks.classList.add('hidden')
                    document.querySelector('.mobileBack').classList.remove('hidden')
                }
                this.selectedLink = "films"
                this.digitalWorksDom.classList.remove('selected')
                this.installationsDom.classList.remove('selected')
                this.filmsDom.classList.add('selected')
                this.aboutDom.classList.remove('selected')
                this.webDesignDom.classList.remove('selected')
                gsap.to(this.camera.instance.position, {x: -1.8, y: 1.3, z: -0.14, duration: 2, ease: "power1.inOut"} )
                gsap.to(this.camera.instance.rotation, {x: 0, y: 0, z: 0,  duration: 2, ease: "power1.inOut"} )

                this.portfolioContainer2.classList.add('hidden')
                gsap.delayedCall(1, () =>
                {
                    this.imagesDom.innerHTML = ""
                    this.imagesDom.classList.remove('active')
                    this.informationDom.innerHTML = 
                    `
                            <a class="syzygy" href="#">Syzygy (2020)</a>
                    <br>
                    <br>
                    <a  class="hecatesThread" href="#">Hecate's Thread (2021)</a>
                    <br>
                    <br>
                    `
                    this.portfolioContainer2.classList.remove('hidden')
                
                    document.querySelector('.syzygy').addEventListener('click', () =>
                    {
                        this.imagesDom.innerHTML = 
                        `
                            <p class="sublinkTitle">SYZYGY (2020)</p>
                            <br>
                            <br>
                            <iframe src="https://player.vimeo.com/video/560710335" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <p class="sublinkParagraph">
                                <br>
                                A collaborative project with dance choreographer <a href="https://www.performancearchitects.ca/" target="_blank">Jennifer Swan</a>, 
                                Syzygy is a three-part multimedia performance that explores the concept of celestial orbit in relation to the spatial framework of the theatre performance. 
                                Rather than the static relationship between audience, stage, and performance, Syzygy proposes an interlaced movement between these three positions. 
                                The chair becomes a symbol of listening which is oriented in a specific direction, at times pointed at the audience, 
                                and at other times ‘within’ the performers themselves.
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                            </p>
                        `
                        this.imagesDom.classList.add('active')
                    })

                    document.querySelector('.hecatesThread').addEventListener('click', () =>
                    {
                        this.imagesDom.innerHTML = 
                        `
                            <p class="sublinkTitle">Hecate's Thread (2021)</p>
                            <iframe src="https://player.vimeo.com/video/560710692" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                            <p class="sublinkParagraph">
                                <br>
                                Grasping for the tangible, the ‘real’, the comforting, 'Hecate's Thread' follows the traversal of an unknown individual from a first-person perspective. 
                                They travel between the physical world and the digital world, blurring the lines that before seemed so clear. What is the thread that connects us together, 
                                grounding us in this new abstract and chaotic space?
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                                <br>
                            </p>
                        `
                        this.imagesDom.classList.add('active')
                    })
                })
                
                
            }
        })

        this.webDesignDom.addEventListener('click', () =>
        {
            this.toWebDesign()
        })

        this.aboutDom.addEventListener('click', () =>
        {
            if(this.selectedLink != "about")
            {
                if(this.mobile === true)
                {
                    this.portfolioContainer2.classList.remove('inactive')
                    this.portfolioLinks.classList.add('hidden')
                    document.querySelector('.mobileBack').classList.remove('hidden')
                }
                this.selectedLink = "about"
                this.digitalWorksDom.classList.remove('selected')
                this.installationsDom.classList.remove('selected')
                this.filmsDom.classList.remove('selected')
                this.aboutDom.classList.add('selected')
                this.webDesignDom.classList.remove('selected')
                gsap.to(this.camera.instance.position, {x: -4.4, y: 1.6, z: 1.56, duration: 2, ease: "power1.inOut"} )
                gsap.to(this.camera.instance.rotation, {x: 0, y: 1.6, z: 0, duration: 2, ease: "power1.inOut"} )

                this.portfolioContainer2.classList.add('hidden')
                gsap.delayedCall(1, () =>
                {
                    // this.imagesDom.innerHTML = `<img class="profile" src="/images/profile.png">`
                    this.imagesDom.classList.remove('active')
                    this.informationDom.innerHTML = 
                    `
                        Julien Darling-Funk is an inter-disciplinary artist from Canada. 
                        His practice shifts between sculptural installations and digital artworks, 
                        where he explores themes often related to the ways in which social and technical 
                        devices of the 21st century permanantly shift our way of life and the way we view the world around us. Important to his work is the act of
                        'close listening'; to hear the smallest voice/sound in the room; to hear
                        the unheard.
                        <br>
                        <br>
                        Beyond his art practice, Julien also works as a <a class="smallWebLink" href="#">Web Designer</a>,
                        producing online digital experiences that push the boundary of
                        how we interact with online content.
                        <br>
                        <br>
                        <a href="/CV2023.pdf">View CV here.</a>
                        <br>
                        <br>
                        <br>
                        <br>
                    `
                    document.querySelector('.smallWebLink').addEventListener('click', () =>
                    {
                        this.toWebDesign()
                    })
                    this.portfolioContainer2.classList.remove('hidden')
                })
            }
        })
    }

    toWebDesign()
    {
        if(this.selectedLink != "webDesign")
        {
            if(this.mobile === true)
            {
                this.portfolioContainer2.classList.remove('inactive')
                this.portfolioLinks.classList.add('hidden')
                document.querySelector('.mobileBack').classList.remove('hidden')
            }
            this.selectedLink = "webDesign"
            this.digitalWorksDom.classList.remove('selected')
            this.installationsDom.classList.remove('selected')
            this.filmsDom.classList.remove('selected')
            this.aboutDom.classList.remove('selected')
            this.webDesignDom.classList.add('selected')
            gsap.to(this.camera.instance.position, {x: -3, y: 1.0, z: 2.8, duration: 2, ease: "power1.inOut"} )
            gsap.to(this.camera.instance.rotation, {x: 0, y: 2.2, z:0, duration: 2, ease: "power1.inOut"} )

            this.portfolioContainer2.classList.add('hidden')
            gsap.delayedCall(1, () =>
            {
                this.imagesDom.innerHTML = ""
                this.imagesDom.classList.remove('active')
                this.informationDom.innerHTML = 
                `
                    Julien is accepting commissions for personalized websites.
                    <br>
                    <br>
                    <a href="https://juliendarling-funk.com/" style="color:aquamarine;font-style:italic;">Click here to learn more...</a>
                    <br>
                `
                this.portfolioContainer2.classList.remove('hidden')
            })
        }
    }

    enter()
    {
        console.log("Entering Website Environment")
        this.world.FPControls = true
        this.world.FPCollisions = true
        this.portfolioContainer.style.visibility = "hidden"
        this.portfolioContainer2.style.visibility = "hidden"
        this.portfolioLinks.classList.add('hidden')
        this.audio.masterVolumeOn()
        gsap.delayedCall(1, () =>
        {
            this.setNavBox('appear')
            this.setNavBox('default')
            this.experience.portfolioMode = false
            this.textAdventure.progressToNextEvent(1)
        })
        this.transformingWebglContainer = true
        gsap.to(this.params, {renderWidth: 100, renderHeight: 100, leftOffset: 0, topOffset: 0, duration: 2, onComplete: () => { this.transformingWebglContainer = false}})
        .play()
    }

    return()
    {
        console.log("Returning to Portfolio")
        this.world.FPControls = false
        this.world.FPCollisions = false
        this.setNavBox('disappear')
        this.setNavBox('hidden')
        this.experience.portfolioMode = true

        gsap.delayedCall(1, () =>
        {
            this.portfolioContainer.style.visibility = "visible"
            this.portfolioContainer2.style.visibility = "visible"
            this.portfolioLinks.classList.remove('hidden')
            this.audio.masterVolumeOff()
        })
        this.transformingWebglContainer = true
        gsap.to(this.params, {renderWidth: 70, renderHeight: 50, leftOffset: 40, topOffset: 0, duration: 2, onComplete: () => { this.transformingWebglContainer = false}})
        .play()
    }

    /**
     * -------------- END OF PORTFOLIO SECTION---------------------------------
     */

    openOS()
    {
        this.audio.play("bootUp")

        this.OSIframe = document.createElement('iframe')
        this.OSIframe.src = './iframe/OS/OS.html'
        this.OSIframe.style.transform = 'translate(-50%,-50%)'
        this.OSIframe.style.left = '50%'
        this.OSIframe.style.top = '50%'
        this.OSIframe.style.position = 'absolute'
        this.OSIframe.style.height = '73vh'
        this.OSIframe.style.width = '73vh'
        this.OSIframe.style.border = 'none'
        this.OSIframe.style.border = '20px solid #676764'


        this.monitorOverlay = document.createElement('img')
        this.monitorOverlay.src = './textures/static/monitor.png'
        this.monitorOverlay.style.height = '100%'
        this.monitorOverlay.style.zIndex = 21
        this.monitorOverlay.style.position = 'absolute'
        this.monitorOverlay.style.left = '50%'
        this.monitorOverlay.style.transform = 'translate(-50%)'
        this.monitorOverlay.style.pointerEvents = 'none'


        this.visuals.style.zIndex = "20"
        this.visuals.appendChild(this.OSIframe)
        this.visuals.appendChild(this.monitorOverlay)

        gsap.delayedCall(0.1, () =>
        {
            this.visuals.style.visibility = 'visible'

        })
    }

    closeOS()
    {
        this.visuals.style.zIndex = "-1"
        this.OSIframe.remove()
    }

    setExperienceContainer(parameter)
    {
        if(parameter)
        {
            this.params.windowMode = parameter
        }
        if(this.params.windowMode === 'fullscreen')
        {
            this.experienceContainer.classList.remove('fullSquare')
            this.experienceContainer.classList.remove('square')
            this.camera.resize()
            this.renderer.resize()
        }
        else if(this.params.windowMode === 'fullSquare')
        {
            this.experienceContainer.classList.add('fullSquare')
            this.experienceContainer.classList.remove('square')
            this.camera.resize()
            this.renderer.resize()
        }
        else if(this.params.windowMode === 'square')
        {
            this.experienceContainer.classList.add('square')
            this.experienceContainer.classList.remove('fullSquare')
            this.camera.resize()
            this.renderer.resize()
        }
    }

    setNavBox(parameter)
    {
        if(parameter)
        {
            this.params.navBoxSetting = parameter
        }
        if(this.params.navBoxSetting === 'default')
        {
            this.experienceContainer.classList.add('navBoxDefault')
            this.experienceContainer.classList.remove('navBoxFull')
        }
        if(this.params.navBoxSetting === 'hidden')
        {
            if(this.textAdventure.typewriterWorking === true)
            {
                this.waitToCloseNav()
            }
            else
            {
                this.experienceContainer.classList.remove('navBoxDefault')
                this.experienceContainer.classList.remove('navBoxFull')
            }
        }
        if(this.params.navBoxSetting === 'fullscreen')
        {
            this.experienceContainer.classList.remove('navBoxDefault')
            this.experienceContainer.classList.add('navBoxFull')
        }
        if(parameter === "disappear")
        {
            this.navBox.style.opacity = "0"
            document.querySelector('.folderTabs').style.opacity = "0"
            document.querySelector('.boxShadow').style.opacity = "0"
            gsap.delayedCall(1, () =>
            {
                this.navBox.style.visibility = "hidden"
                this.navBox.style.zIndex = "0"
                document.querySelector('.boxShadow').style.visibility = "hidden"
                document.querySelector('.folderTabs').style.visibility = "hidden"
            })
 
        }
        if(parameter === "appear")
        {
            document.querySelector('.boxShadow').style.visibility = "visible"
            document.querySelector('.folderTabs').style.visibility = "visible"
            this.navBox.style.visibility = "visible"
            this.navBox.style.opacity = "1"
            document.querySelector('.folderTabs').style.opacity = "1"
            document.querySelector('.boxShadow').style.opacity = "1"
            this.navBox.style.zIndex = "10"

        }
    }

    waitToCloseNav()
    {
        if(this.waitingToCloseNav === false)
        {
            this.waitingToCloseNav = true
            this.params.navBoxSetting = 'hidden'
            this.waitToCloseNavInterval = setInterval(() =>
            {
                if(this.textAdventure.typewriterWorking === false)
                {
                    clearInterval(this.waitToCloseNavInterval)
                    gsap.delayedCall(3,() =>
                    {
                        if(this.firstPerson.pointerLockControls.isLocked === false && this.firstPerson.disengaged === false)
                        {
                            this.waitingToCloseNav = false
                        }
                        else if(this.params.navBoxSetting === 'hidden' && this.textAdventure.typewriterWorking === false)
                        {
                            this.experienceContainer.classList.remove('navBoxDefault')
                            this.experienceContainer.classList.remove('navBoxFull')
                            this.waitingToCloseNav = false
                        }
                        else
                        {
                            this.waitingToCloseNav = false
                            this.waitToCloseNav()
                        }
                    })  
                }
            }, 100)
        }
    }

    openNavIfClose()
    {
        if(this.params.navBoxSetting === 'hidden')
        {
            this.setNavBox('default')
            this.waitToCloseNav()
        }
    }

    pinScrollToBottom()
    {
        this.textBoxHeight = 0
        setInterval(() =>
        {
            if(this.textBoxHeight != this.textBox.scrollHeight)
            {
                this.textBox.scrollTo(0,this.textBox.scrollHeight)
            }
            this.textBoxHeight = this.textBox.scrollHeight
            
        }, 50)
    }

    webGLContained()
    {
        this.webGLContainer.style.maxHeight = String(this.params.renderHeight) + "%"
        this.webGLContainer.style.maxWidth = String(this.params.renderWidth) + "%"
        this.webGLContainer.style.transform = "translate(" + String(this.params.leftOffset - 50) + "%, " + String(this.params.topOffset - 50) + "%)"
        this.webGLContainedHeight = parseInt(this.webGLContainer.clientHeight)
        this.webGLContainedWidth = parseInt(this.webGLContainer.clientWidth)
        if(this.renderer.params.postprocessing === true)
        {
            this.renderer.composer.setSize(this.webGLContainedWidth, this.webGLContainedHeight)
            this.renderer.composer.setPixelRatio(window.devicePixelRatio, 1)
        }
        else if(this.renderer.params.postprocessing === false)
        {
            this.renderer.instance.setSize(this.webGLContainedWidth, this.webGLContainedHeight)
            this.renderer.instance.setPixelRatio(window.devicePixelRatio, 1)
        }
        this.camera.instance.aspect =  this.webGLContainedWidth / this.webGLContainedHeight
        this.camera.instance.updateProjectionMatrix()
    }

    update()
    {
        if(this.transformingWebglContainer === true)
        {
            this.webGLContainer.style.maxHeight = String(this.params.renderHeight) + "%"
            this.webGLContainer.style.maxWidth = String(this.params.renderWidth) + "%"
            this.webGLContainer.style.transform = "translate(" + String(this.params.leftOffset - 50) + "%, " + String(this.params.topOffset - 50) + "%)"
            this.webGLContainedHeight = parseInt(this.webGLContainer.clientHeight)
            this.webGLContainedWidth = parseInt(this.webGLContainer.clientWidth)
            if(this.renderer.params.postprocessing === true)
            {
                this.renderer.composer.setSize(this.webGLContainedWidth, this.webGLContainedHeight)
                this.renderer.composer.setPixelRatio(window.devicePixelRatio, 1)
            }
            else if(this.renderer.params.postprocessing === false)
            {
                this.renderer.instance.setSize(this.webGLContainedWidth, this.webGLContainedHeight)
                this.renderer.instance.setPixelRatio(window.devicePixelRatio, 1)
            }
            this.camera.instance.aspect =  this.webGLContainedWidth / this.webGLContainedHeight
            this.camera.instance.updateProjectionMatrix()
        }
    }

    /**------------------------------------------------------------------
     *--------------------------------DEBUG------------------------------
     *-------------------------------------------------------------------
    */

    setDebug()
    {
        if(this.debug.active)
        {
            this.debugFolder = this.debug.osDebugFolder
            this.debugFolder.add(this.params, 'OSOpened').onChange(() =>
            {
                if(this.params.OSOpened === true)
                {
                    this.openOS()
                }
                else if(this.params.OSOpened === false)
                {
                    this.closeOS()
                }
            })
            this.renderDebugFolder = this.debug.renderDebugFolder
            this.renderDebugFolder.add(this.params, 'renderHeight', 0, 100)
            .onChange(() =>
            {
                this.webGLContainer.style.maxHeight = String(this.params.renderHeight) + "%"
                this.webGLContainedHeight = parseInt(this.webGLContainer.clientHeight)
                this.webGLContainedWidth = parseInt(this.webGLContainer.clientWidth)
                if(this.renderer.params.postprocessing === true)
                {
                    this.renderer.composer.setSize(this.webGLContainedHeight, this.webGLContainedHeight)
                    this.renderer.composer.setPixelRatio(window.devicePixelRatio, 1)
                }
                else if(this.renderer.params.postprocessing === false)
                {
                    this.renderer.instance.setSize(this.webGLContainedHeight, this.webGLContainedHeight)
                    this.renderer.instance.setPixelRatio(window.devicePixelRatio, 1)
                }
                this.camera.instance.aspect =  this.webGLContainedWidth / this.webGLContainedHeight
                this.camera.instance.updateProjectionMatrix()
            })
            this.renderDebugFolder.add(this.params, 'renderWidth', 0, 100)
            .onChange(() =>
            {
                this.webGLContainer.style.maxWidth = String(this.params.renderWidth) + "%"
                this.webGLContainedHeight = parseInt(this.webGLContainer.clientHeight)
                this.webGLContainedWidth = parseInt(this.webGLContainer.clientWidth)
                if(this.renderer.params.postprocessing === true)
                {
                    this.renderer.composer.setSize(this.webGLContainedHeight, this.webGLContainedHeight)
                    this.renderer.composer.setPixelRatio(window.devicePixelRatio, 1)
                }
                else if(this.renderer.params.postprocessing === false)
                {
                    this.renderer.instance.setSize(this.webGLContainedHeight, this.webGLContainedHeight)
                    this.renderer.instance.setPixelRatio(window.devicePixelRatio, 1)
                }
                this.camera.instance.aspect =  this.webGLContainedWidth / this.webGLContainedHeight
                this.camera.instance.updateProjectionMatrix()
            })
        //     this.debugFolder.add(this.params, 'windowMode', [ 'fullscreen', 'fullSquare', 'square']).onChange(() =>
        //     {
        //         this.setExperienceContainer(this.params.windowMode)
        //     })
        //     this.debugFolder.add(this.params, 'navBoxSetting', [ 'default', 'hidden', 'fullscreen']).onChange(() =>
        //     {
        //         this.setNavBox(this.params.navBoxSetting)
        //     })
        //     this.debugFolder.close()
            
        }
    }
}